const t = (o) => !!(o && o.getVelocity);
export {
  t as isMotionValue
};
